import queryString from "query-string";
import computeSortBy from "./computeSortBy";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function parseQueryForUiState(uiState, location, context) {
  const {
    search,
    order_by,
    page,
    availabilities,
    kinds,
    category,
    clothes,
    accessories,
    sizes,
    colors,
    seasons,
    sleeves,
    legs,
    brands,
  } = queryString.parse(location.search, { arrayFormat: "bracket" });

  const kindsArray = typeof kinds === "string" ? [kinds] : kinds;
  const categoryGrouped = [...(category || []), ...(clothes || []), ...(accessories || [])];

  const newUiState = { ...uiState };

  newUiState[mainIndex].query = search;
  newUiState[mainIndex].sortBy = computeSortBy(context, order_by);
  newUiState[mainIndex].page = page > 1 ? page : 1;

  if (availabilities === "all") {
    newUiState[mainIndex].refinementList.in_stock = ["false", "true"];
  } else if (availabilities === "in_stock") {
    newUiState[mainIndex].refinementList.in_stock = ["true"];
  }

  newUiState[mainIndex].refinementList.segment =
    newUiState[mainIndex].refinementList.segment || kindsArray || [];
  newUiState[mainIndex].refinementList.category =
    newUiState[mainIndex].refinementList.category || categoryGrouped || [];

  if (newUiState[mainIndex].refinementList.in_stock?.includes("false")) {
    newUiState[mainIndex].refinementList.sizes =
      sizes || newUiState[mainIndex].refinementList.sizes || [];
  } else {
    newUiState[mainIndex].refinementList.available_sizes =
      sizes || newUiState[mainIndex].refinementList.available_sizes || [];
  }

  newUiState[mainIndex].refinementList.colors =
    newUiState[mainIndex].refinementList.colors || colors || [];
  newUiState[mainIndex].refinementList.season =
    newUiState[mainIndex].refinementList.season || seasons || [];
  newUiState[mainIndex].refinementList.sleeves =
    newUiState[mainIndex].refinementList.sleeves || sleeves || [];
  newUiState[mainIndex].refinementList.legs =
    newUiState[mainIndex].refinementList.legs || legs || [];
  newUiState[mainIndex].refinementList["brand.name"] =
    newUiState[mainIndex].refinementList["brand.name"] || brands || [];

  return newUiState;
}
